/** Hero / OG banner paths (WebP generated at build from bannerImage.png) */
export const BANNER_IMAGE_PNG = '/bannerImage.png';
export const BANNER_IMAGE_WEBP = '/bannerImage.webp';

export const toWebpPath = (src: string): string => src.replace(/\.(jpe?g|png)$/i, '.webp');
